import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const SECTIONS = [
  {
    title: "1. Information We Collect",
    body: "Account information: name, email, phone number, photo. Health information: medical records you choose to upload. Usage data: appointment history, interaction with the app. Device information: device type, OS version, push notification tokens.",
  },
  {
    title: "2. How We Use Your Information",
    body: "To provide and improve our queue management service. To send appointment reminders and notifications. To process bookings and connect you with healthcare providers. To comply with legal obligations.",
  },
  {
    title: "3. Data Sharing",
    body: "We share your information only with healthcare providers you book appointments with (your name, contact info, medical records) and service providers who help us operate (cloud hosting, push notifications). We do not sell your personal data to third parties.",
  },
  {
    title: "4. Data Retention",
    body: "We retain your data for as long as your account is active. After account deletion, data is permanently erased within 30 days except where required by law.",
  },
  {
    title: "5. Your Rights",
    body: "You may access, update, or delete your personal data at any time via the app. Withdraw consent for notifications at any time. Request a copy of your data.",
  },
  {
    title: "6. Security",
    body: "We use industry-standard encryption (HTTPS, AES-256) to protect your data in transit and at rest.",
  },
  {
    title: "7. Contact",
    body: "For privacy concerns, contact us at support@queuemed.com.",
  },
  {
    title: "8. Changes to This Policy",
    body: "We may update this policy. We will notify you of material changes via the app or email.",
  },
];

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <h1 className="font-display font-bold text-3xl sm:text-4xl text-foreground tracking-tight">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground mt-1 mb-8">Last updated: May 2026</p>
        <div className="space-y-6">
          {SECTIONS.map((s, i) => (
            <div key={i}>
              <h2 className="font-display font-semibold text-lg text-foreground">{s.title}</h2>
              <p className="text-sm text-foreground mt-1.5 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
